import React, { useState, FC } from "react";
import { useDispatch } from "react-redux";
import { IconButton, Box } from "@mui/material";
import {
  MainContainer,
  OrderStyles,
  SpaceBetween,
  TitleText,
  Text,
  PriceText,
  DeleteIconWrapper,
  RightActions,
  ActionRow,
  CustomDrop,
  StyledImage,
  StyledButton,
} from "./wishListStyles";
import wishlistDeleteIcon from "../../assets/deleteIcon.svg";
import CustomDropdown from "../../common/CustomDropdown";
import { ProductListingProps } from "../../types/ProductList";
import { addItem } from "../../redux/features/slices/cartSlice";
import { useUpdateCart } from "../../queries/cart";
import { cartDataMapper } from "../../utils/cartDataMapper";

interface WishListItemProps extends ProductListingProps {
  onDelete?: () => void;
}

export const WishListItem: FC<WishListItemProps> = ({
  id,
  name,
  images,
  abv,
  ibu,
  price,
  availableQuantity20L,
  availableQuantity30L,
  availableQuantity50L,
  isOutOfStock,
  onDelete,
}) => {
  const dispatch = useDispatch();
  const [selectedCategory, setSelectedCategory] = useState<string>("20");
  const updateCart = useUpdateCart();

  const handleCategoryChange = (selected: string) => {
    setSelectedCategory(selected);
  };

  const handleAddToCart = async () => {
    if (isOutOfStock) return;

    let availableQuantity = 0;
    if (+selectedCategory === 20) availableQuantity = availableQuantity20L || 0;
    else if (+selectedCategory === 30)
      availableQuantity = availableQuantity30L || 0;
    else if (+selectedCategory === 50)
      availableQuantity = availableQuantity50L || 0;

    if (availableQuantity > 0) {
      try {
        const updateCartData = {
          productId: id,
          unit: 1,
          quantity: +selectedCategory,
        };
        const updatedCart = await updateCart.mutateAsync({
          cartData: [updateCartData],
        });
        const storeData = cartDataMapper(updatedCart?.Products);
        dispatch(addItem(storeData));

        if (onDelete) {
          onDelete();
        }
      } catch (error) {
        console.error("Error adding item to cart:", error);
      }
    }
  };

  return (
    <MainContainer>
      <StyledImage src={images ?? ""} alt={name} />
      <OrderStyles>
        <SpaceBetween>
          <TitleText>{name}</TitleText>
          <Text>
            ({abv}% ABV) IBU - {ibu}
          </Text>
          <PriceText>Rs {price}/L</PriceText>
        </SpaceBetween>

        <RightActions>
          <DeleteIconWrapper>
            <IconButton onClick={onDelete}>
              <Box component="img" alt="Delete" src={wishlistDeleteIcon} />
            </IconButton>
          </DeleteIconWrapper>

          <ActionRow>
            <CustomDrop>
              <CustomDropdown
                label={`${selectedCategory} L`}
                value={selectedCategory}
                onChange={handleCategoryChange}
                options={[
                  { value: "20", label: "20L" },
                  { value: "30", label: "30L" },
                  { value: "50", label: "50L" },
                ]}
              />
            </CustomDrop>

            <StyledButton
              variant="outlined"
              onClick={handleAddToCart}
              disabled={isOutOfStock}
            >
              {isOutOfStock ? "Out of Stock" : "Add to Cart"}
            </StyledButton>
          </ActionRow>
        </RightActions>
      </OrderStyles>
    </MainContainer>
  );
};
